const ActivePolicies = ({ policies }) => {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-header-title">Active Policies</h3>
      </div>
      <div className="card-body policies-list">
        {policies.map((policy) => (
          <div key={policy.id} className="policy-card">
            <div className="policy-card-header">
              <span className="policy-icon">{policy.icon}</span>
              <span className="policy-type">{policy.type}</span>
              <span className="badge badge--green">{policy.status}</span>
            </div>
            <div className="policy-details">
              <p className="policy-detail-line">
                {policy.policyNumber} • {policy.carrier} • {policy.premium}
              </p>
              <p className="policy-detail-line">
                Exp: {policy.expiration} • {policy.details}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivePolicies;
